import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import AppProvider from "./providers/AppProvider";
import { LoadScript } from "@react-google-maps/api";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const GOOGLE_MAPS_APIKEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
const client = new QueryClient();
root.render(
  <React.StrictMode>
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_APIKEY} libraries={["places"]}>
      <QueryClientProvider client={client}>
        <AppProvider>
          <BrowserRouter>
            <ToastContainer />
            <App />
          </BrowserRouter>
        </AppProvider>
      </QueryClientProvider>
    </LoadScript>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
